"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var NadpisFormulare = styled_components_1.default.h2(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-style: normal;\n  font-weight: normal;\n  font-size: 28px;\n  line-height: 140%;\n  margin: 0px;\n  margin-bottom: 1rem;\n  color: #000000;\n"], ["\n  font-style: normal;\n  font-weight: normal;\n  font-size: 28px;\n  line-height: 140%;\n  margin: 0px;\n  margin-bottom: 1rem;\n  color: #000000;\n"])));
var FormHeader = function (_a) {
    var text = _a.text;
    return react_1.default.createElement(NadpisFormulare, null, text);
};
exports.default = FormHeader;
var templateObject_1;
